/**
 * Filter option constants for the ItineraryExplorer page.
 * Used by filter chip dropdowns and URL search param validation.
 */

export const COST_PRESETS = [
  { label: 'Under $500', max: 500 },
  { label: '$500 - $1,500', min: 500, max: 1500 },
  { label: '$1,500 - $3,000', min: 1500, max: 3000 },
  { label: '$3,000+', min: 3000 },
];

export const DAYS_PRESETS = [
  { label: 'Weekend (1-3)', min: 1, max: 3 },
  { label: 'Short Trip (4-7)', min: 4, max: 7 },
  { label: 'Two Weeks (8-14)', min: 8, max: 14 },
  { label: 'Extended (15+)', min: 15 },
];

export const STYLES = [
  'cultural',
  'adventure',
  'culinary',
  'nature',
  'family',
  'luxury',
  'budget',
  'relaxed',
];

export const STYLE_LABELS = {
  cultural: 'Cultural',
  adventure: 'Adventure',
  culinary: 'Culinary',
  nature: 'Nature',
  family: 'Family',
  luxury: 'Luxury',
  budget: 'Budget',
  relaxed: 'Relaxed',
};

export const REGIONS = [
  'Europe',
  'Asia',
  'Americas',
  'Africa',
  'Middle East',
  'Oceania',
];

export const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest' },
  { value: 'most_saved', label: 'Most Saved' },
  { value: 'highest_rated', label: 'Highest Rated' },
  { value: 'ai_match', label: 'AI Match' },
];

/**
 * Gradient placeholders for itineraries with null imageUrl.
 * Keyed by travelStyle value.
 */
export const STYLE_GRADIENTS = {
  cultural:  'linear-gradient(135deg, #1e3a5f 0%, #2d6a4f 100%)',
  adventure: 'linear-gradient(135deg, #1a1a2e 0%, #4a1942 100%)',
  culinary:  'linear-gradient(135deg, #3d1a00 0%, #7c4700 100%)',
  nature:    'linear-gradient(135deg, #1b4332 0%, #0d3b2e 100%)',
  family:    'linear-gradient(135deg, #1a3a6b 0%, #2855a0 100%)',
  luxury:    'linear-gradient(135deg, #1c1c1e 0%, #2c2c2e 100%)',
  budget:    'linear-gradient(135deg, #0f3057 0%, #005f73 100%)',
  relaxed:   'linear-gradient(135deg, #2d6a4f 0%, #40916c 100%)',
};
